import AgreementDocumentPanel from './AgreementDocumentPanel.component';

export default AgreementDocumentPanel;
